import { getIntelFreshnessDotColor, getIntelAge, getIntelFreshnessColor } from '../../constants/attackCalculator';

interface IntelFreshnessIndicatorProps {
  capturedAt: string;
  label?: string;
}

export function IntelFreshnessIndicator({ capturedAt, label }: IntelFreshnessIndicatorProps) {
  const dotColor = getIntelFreshnessDotColor(capturedAt);
  const textColor = getIntelFreshnessColor(capturedAt);
  const age = getIntelAge(capturedAt);

  return (
    <span className={`inline-flex items-center gap-1 text-xs ${textColor}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dotColor}`} />
      {label && <span>{label}:</span>}
      <span>{age}</span>
    </span>
  );
}
